import Vue from 'vue'
import Router from 'vue-router'
import { useGlobalStore } from '@/stores/global';

/**
 * @description 判断是否为由导航守卫重定向触发的可忽略报错。
 * @param {Error} error 待判断的异常对象。
 * @returns {boolean} 若为可忽略报错则返回 true。
 */
function isRedirectNavigationError(error) {
  return Boolean(
    error &&
    typeof error.message === 'string' &&
    error.message.includes('Redirected when going from')
  );
}

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((error) => {
    if (isRedirectNavigationError(error)) {
      return error;
    }
    throw error;
  });
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((error) => {
    if (isRedirectNavigationError(error)) {
      return error;
    }
    throw error;
  });
};
import aboutUs from '@/views/aboutUs'
import agreement from '@/views/agreement'
import echarts from '@/views/echarts'
import picke from '@/views/picke'
import bulletFrame from '@/components/bulletFrame'
import serviceAgreement from '@/views/serviceAgreement'
import integral from '@/views/integral'
import integralRecord from '@/views/components/integralRecord'
import awardRecord from '@/views/components/awardRecord'
import writeOff from '@/views/writeOff'
import writeOffInformation from '@/views/components/writeOffInformation'
import screen from '@/views/screen'
import screendetail from '@/views/screendetail'
import see from '@/views/see'
import stepNumber from '@/views/stepNumber/index'
import login from '@/views/login/index'
import register from '@/views/register/index'
import bloodPressure from '@/views/bloodPressure/index'
import binding from '@/views/binding/index'
import recordList from '@/views/recordList/index'
import unbind from '@/views/binding/unbind'
import afterSales from '@/views/binding/afterSales'
import information from '@/views/information/index'
import disease from '@/views/information/disease'
import theHeartList from '@/views/theHeart/theHeartList'
import ecg from '@/views/theHeart/ecg'
import theHeart from '@/views/theHeart/index'
import canvas from '@/views/canvas/index'
import sleep from '@/views/sleep/index'
import download from '@/views/download'
import physicalCardDownload from '@/views/PhysicalCardDownload'
Vue.use(Router)
import service from '@/views/service/index'
import newIndex from '@/views/service/newIndex'
import admission from '@/views/detailsH5/admission'
import doctor from '@/views/detailsH5/doctor'
import medicalGuardianship from '@/views/detailsH5/medicalGuardianship'
import medicalReturn from '@/views/detailsH5/medicalReturn'
import butlerservice from '@/views/detailsH5/butlerservice'
import service1 from '@/views/detailsH5/service'
import unlocking from '@/views/detailsH5/unlocking'
import toilet from '@/views/detailsH5/toilet'
import urgent from '@/views/detailsH5/urgent'
import assist from '@/views/detailsH5/assist'
import outpatientAssist from '@/views/detailsH5/outpatientAssist'
import inpatientCollaboration from '@/views/detailsH5/inpatientCollaboration'
import expeditedExamination from '@/views/detailsH5/expeditedExamination'
import admissionEscort from '@/views/detailsH5/admissionEscort'
import secondOpinion from '@/views/detailsH5/secondOpinion'
import multidisciplinaryConsultation from '@/views/detailsH5/multidisciplinaryConsultation'
import overseasMedicalArrangement from '@/views/detailsH5/overseasMedicalArrangement'
import globalMedicineSearch from '@/views/detailsH5/globalMedicineSearch'
import postDischargeCareGuidance from '@/views/detailsH5/postDischargeCareGuidance'
import postMedicalFollowUp from '@/views/detailsH5/postMedicalFollowUp'
import makeanappointment from '@/views/detailsH5/makeanappointment'
import sharing from '@/views/detailsH5/sharing'
import equity from '@/views/detailsH5/equity'
import taiheEquity from '@/views/detailsH5/taiheEquity'
import taiheHealthMonitoring from '@/views/detailsH5/taiheHealthMonitoring'
import informationGathering from '@/views/informationGathering/index'
import jdPurchase from '@/views/jdPurchase/index'
import rescue from '@/views/rescue/index'
import rescueProcessing from '@/views/rescueProcessing/index'

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    // 跳转首页滚动条不需要回到顶部
    const globalStore = useGlobalStore();
    if (!globalStore.keepAliveList.includes(to.name)) {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/download',//下载页面
      name: 'download',
      component: download,
      meta: { title: '下载页面', noAuth: true }
    },
    {
      path: '/physicalCardDownload',//实体卡下载APP
      name: 'physicalCardDownload',
      component: physicalCardDownload,
      meta: { title: '实体卡下载APP', noAuth: true }
    },
    {
      path: '/wechat-scan',
      name: 'wechatScan',
      component: () => import('@/views/wechat/WechatScanPage'),
      meta: { title: '微信扫码', noAuth: true }
    },
    {
      path: '/login/warehouse',
      name: 'warehouseLogin',
      component: () => import('@/views/login/WarehouseLogin'),
      meta: { title: '仓库登录', noAuth: true }
    },
    {
      path: '/stock-in-manager',
      name: 'stockInManager',
      component: () => import('@/views/warehouse/StockInManager'),
      meta: { title: '商品出入库管理', noAuth: true }
    },
    {
      path: '/stock-in-manager/goods-operation',
      name: 'stockInManagerGoodsOperation',
      component: () => import('@/views/warehouse/GoodsOperation'),
      meta: { title: '出库操作', noAuth: true }
    },
    {
      path: '/stock-in-manager/after-sales-detail',
      name: 'stockInManagerAfterSalesDetail',
      component: () => import('@/views/warehouse/AfterSalesDetail'),
      meta: { title: '售后', noAuth: true }
    },
    {
      path: '/stock-in-manager/order-list',
      name: 'stockInManagerOrderList',
      component: () => import('@/views/warehouse/OrderList'),
      meta: { title: '订单列表', noAuth: true }
    },
    {
      path: '/stock-in-manager/order-detail-view',
      name: 'stockInManagerOrderDetailView',
      component: () => import('@/views/warehouse/OrderDetailView'),
      meta: { title: '订单详情', noAuth: true }
    },
    {
      path: '/informationGathering',//信息收集
      name: 'informationGathering',
      component: informationGathering
    },
    {
      path: "/aboutUs",//关于我们
      name: 'aboutUs',
      component: aboutUs
    }, {
      path: "/agreement",//隐私协议
      name: 'agreement',
      component: agreement
    }, {
      path: "/echarts",//图表测试
      name: 'echarts',
      component: echarts
    }, {
      path: "/picke",//图表测试
      name: 'picke',
      component: picke
    }, {
      path: "/bulletFrame",//图表测试
      name: 'bulletFrame',
      component: bulletFrame
    }, {
      path: "/serviceAgreement",//服务协议
      name: 'serviceAgreement',
      component: serviceAgreement
    },     {
      path: '/jdPurchase',//京东购买页
      name: 'jdPurchase',
      component: jdPurchase,
      meta: { title: '商品详情', noAuth: true }
    }, {
      path: '/onClickRescue',//一键救援页
      name: 'onClickRescue',
      component: rescue,
      meta: { title: '一键救援', noAuth: true }
    }, {
      path: '/rescueProcessing',//救援处理中页
      name: 'rescueProcessing',
      component: rescueProcessing,
      meta: { title: '启动救援中', noAuth: true }
    }, {
      path: '/integral',//积分中心
      name: 'integral',
      component: integral,
      meta: { title: '积分中心' }
    }, {
      path: '/equity',//权益详情
      name: 'equity',
      component: equity,
      meta: { title: '详情' }
    }, {
      path: '/taiheEquity',//泰和君安权益详情
      name: 'taiheEquity',
      component: taiheEquity,
      meta: { title: '权益详情' }
    }, {
      path: '/taiheHealthMonitoring',//泰和君安健康监测服务权益详情
      name: 'taiheHealthMonitoring',
      component: taiheHealthMonitoring,
      meta: { title: '权益详情' }
    }, {
      path: '/integralRecord',//积分记录
      name: 'integralRecord',
      component: integralRecord
    }, {
      path: '/awardRecord',//获奖记录
      name: 'awardRecord',
      component: awardRecord
    }, {
      path: '/service',//服务
      name: 'service',
      component: service
    }, {
      path: '/newIndex',//服务
      name: 'newIndex',
      component: newIndex
    }, {
      path: '/admission',//入院
      name: 'admission',
      component: admission
    }, {
      path: '/medicalReturn',
      name: 'medicalReturn',
      component: medicalReturn
    }, {
      path: '/butlerservice',
      name: 'butlerservice',
      component: butlerservice
    }, {
      path: '/service1',
      name: 'service1',
      component: service1
    }, {
      path: '/unlocking',
      name: 'unlocking',
      component: unlocking
    }, {
      path: '/assist',
      name: 'assist',
      component: assist
    }, {
      path: '/outpatientAssist',
      name: 'outpatientAssist',
      component: outpatientAssist
    }, {
      path: '/inpatientCollaboration',
      name: 'inpatientCollaboration',
      component: inpatientCollaboration
    }, {
      path: '/expeditedExamination',
      name: 'expeditedExamination',
      component: expeditedExamination
    }, {
      path: '/admissionEscort',
      name: 'admissionEscort',
      component: admissionEscort
    }, {
      path: '/secondOpinion',
      name: 'secondOpinion',
      component: secondOpinion
    }, {
      path: '/multidisciplinaryConsultation',
      name: 'multidisciplinaryConsultation',
      component: multidisciplinaryConsultation
    }, {
      path: '/overseasMedicalArrangement',
      name: 'overseasMedicalArrangement',
      component: overseasMedicalArrangement
    }, {
      path: '/globalMedicineSearch',
      name: 'globalMedicineSearch',
      component: globalMedicineSearch
    }, {
      path: '/postDischargeCareGuidance',
      name: 'postDischargeCareGuidance',
      component: postDischargeCareGuidance
    }, {
      path: '/postMedicalFollowUp',
      name: 'postMedicalFollowUp',
      component: postMedicalFollowUp
    }, {
      path: '/sharing',
      name: 'sharing',
      component: sharing
    }, {
      path: '/makeanappointment',
      name: 'makeanappointment',
      component: makeanappointment
    }, {
      path: '/urgent',
      name: 'urgent',
      component: urgent
    }, {
      path: '/toilet',
      name: 'toilet',
      component: toilet
    }, {
      path: '/medicalGuardianship',
      name: 'medicalGuardianship',
      component: medicalGuardianship
    }, {
      path: '/doctor',//医生
      name: 'doctor',
      component: doctor
    }, {
      path: '/writeOff',//核销
      name: 'writeOff',
      component: writeOff
    }, {
      path: '/screendetail',//核销
      name: 'screendetail',
      component: screendetail
    }, {
      path: '/writeOffInformation',//核销
      name: 'writeOffInformation',
      component: writeOffInformation
    }, {
      path: '/screen',//症状筛选
      name: 'screen',
      component: screen
    }, {
      path: '/see',//症状筛选查看
      name: 'see',
      component: see
    }, {
      path: '/stepNumber',//步数页
      name: 'stepNumber',
      component: stepNumber
    }, {
      path: '/sleep',//睡眠页
      name: 'sleep',
      component: sleep
    }, {
      path: '/bloodPressure',//血压页
      name: 'bloodPressure',
      component: bloodPressure
    }, {
      path: '/login',//登录页
      name: 'login',
      component: login
    }, {
      path: '/register',//注册页
      name: 'register',
      component: register
    }, {
      path: '/binding',//未绑定设备页面
      name: 'binding',
      component: binding
    }, , {
      path: '/recordList',//记录页面
      name: 'recordList',
      component: recordList
    },
    {
      path: '/disease',//我得资料
      name: 'disease',
      component: disease,
      meta: { title: '疾病史选择' }
    }, {
      path: '/information',//我得资料
      name: 'information',
      component: information,
      meta: { title: '个人信息' }
    }, {
      path: '/unbind',//解绑设备页面
      name: 'unbind',
      component: unbind
    }, , {
      path: '/afterSales',//售后页面
      name: 'afterSales',
      component: afterSales
    }, {
      path: '/theHeart',//心电图
      name: 'theHeart',
      component: theHeart
    }, {
      path: '/theHeartList',//心电图
      name: 'theHeartList',
      component: theHeartList
    }, {
      path: '/pdfViewer',//PDF查看器
      name: 'pdfViewer',
      component: () => import('@/views/theHeart/PdfViewer')
    }, {
      path: '/ecgAnalysis',
      name: 'ecgAnalysis',
      component: () => import('@/views/theHeart/EcgAnalysis')
    }, {
      path: '/ecgAnalysisEvent',
      name: 'ecgAnalysisEvent',
      component: () => import('@/views/theHeart/EcgAnalysisEvent')
    }, {
      path: '/ecg',//心电图
      name: 'ecg',
      component: ecg
    }, {
      path: '/canvas',//心电图
      name: 'canvas',
      component: canvas
    }, {
      path: '/401',
      name: '401',
      component: () => import('@/views/401'),
      hidden: true,
    },
    // 我的
    {
      path: '/mine',
      name: 'mine',
      component: () => import('@/views/mine/index/mine'),
      meta: { title: '我的' }
    },
    // 我的
    {
      path: '/zb',
      name: 'zb',
      component: () => import('@/views/mine/index/zb'),
      meta: { title: '我的' }
    },
    // 我的
    {
      path: '/rb',
      name: 'rb',
      component: () => import('@/views/mine/index/rb'),
      meta: { title: '我的' }
    },
    // 预警事件
    {
      path: '/warnEventList',
      name: 'warnEventList',
      component: () => import('@/views/mine/warnEvent/warnEventList'),
      meta: { title: '预警事件' }
    },
    // 意见反馈
    {
      path: '/feedback',
      name: 'feedback',
      component: () => import('@/views/mine/feedback/feedback'),
      meta: { title: '意见反馈' }
    },
    // 健康调查问卷
    {
      path: '/healthSurvey',
      name: 'healthSurvey',
      component: () => import('@/views/mine/healthSurvey/index'),
      meta: { title: '健康调查问卷' }
    },
    // 健康监测
    {
      path: '/healthHomePage',
      name: 'healthHomePage',
      component: () => import('@/views/health/index/health'),
      meta: { title: '首页' }
    },
    // 聚合页：图标切换模块（参考新 UI）
    {
      path: '/health-icon-switch',
      name: 'healthIconSwitch',
      component: () => import('@/views/health/healthIconSwitch/index'),
      meta: { title: '首页' }
    },
    {
      path: '/health-icon-switch/family-members',
      name: 'healthIconSwitchFamilyMembers',
      component: () => import('@/views/health/healthIconSwitch/familyMemberList'),
      meta: { title: '家庭成员管理' }
    },
    {
      path: '/health-icon-switch/add-family',
      name: 'healthIconSwitchAddFamily',
      component: () => import('@/views/health/healthIconSwitch/addFamilyMember'),
      meta: { title: '添加家人' }
    },
    {
      path: '/device-home',
      name: 'deviceHome',
      component: () => import('@/views/health/deviceHome/index'),
      meta: { title: '设备' }
    },
    {
      path: '/service-dashboard',
      name: 'serviceDashboard',
      component: () => import('@/views/health/serviceDashboard/index'),
      meta: { title: '服务' }
    },
    // 健康（空白中转页）
    {
      path: '/health',
      name: 'health',
      component: () => import('@/views/health/index/healthRedirect'),
      meta: { title: '首页' }
    },
    {
      path: '/oldAgeHealth',
      name: 'oldAgeHealth',
      component: () => import('@/views/health/index/oldAgeHealth'),
      meta: { title: '首页' }
    },
    // 心率详情
    {
      path: '/heartRateDetails',
      name: 'heartRateDetails',
      component: () => import('@/views/health/heartRateDetails/heartRateDetails'),
      meta: { title: '心率' }
    },
    // 血氧饱和度详情
    {
      path: '/bloodOxygen',
      name: 'bloodOxygen',
      component: () => import('@/views/health/bloodOxygen/bloodOxygen'),
      meta: { title: '血氧饱和度' }
    },
    // 皮肤温度详情
    {
      path: '/skinTemperature',
      name: 'skinTemperature',
      component: () => import('@/views/health/skinTemperature/skinTemperature'),
      meta: { title: '皮肤温度' }
    },
    // 中医首页
    {
      path: '/chineseMedicineIndex',
      name: 'chineseMedicineIndex',
      component: () => import('@/views/chineseMedicine/index'),
      meta: { title: '中医报告' }
    },
    // 健康报告
    {
      path: '/health-report',
      name: 'healthReport',
      component: () => import('@/views/healthReport/index'),
      meta: { title: '健康报告' }
    },
    {
      path: '/health-report-list',
      name: 'healthReportList',
      component: () => import('@/views/healthReport/healthReportList/index'),
      meta: { title: '健康报告' }
    },
    {
      path: '/health-report-failed-list',
      name: 'healthReportFailedList',
      component: () => import('@/views/healthReport/healthReportFailedList/index'),
      meta: { title: '失败健康报告' }
    },
    {
      path: '/health-daily-report-list',
      name: 'healthDailyReportList',
      component: () => import('@/views/healthReport/healthDailyReportList/index'),
      meta: { title: '健康日报' }
    },
    {
      path: '/health-weekend-report-list',
      name: 'healthWeekendReportList',
      component: () => import('@/views/healthReport/healthWeekendReportList/index'),
      meta: { title: '健康周报' }
    },
    {
      path: '/health-weekend-report-detail',
      name: 'healthWeekendReportDetail',
      component: () => import('@/views/healthReport/healthWeekendReportDetail/index'),
      meta: { title: '健康周报详情' }
    },
    {
      path: '/health-daily-report-detail',
      name: 'healthDailyReportDetail',
      component: () => import('@/views/healthReport/healthDailyReportDetail/index'),
      meta: { title: '健康日报详情' }
    },
    // 中医首页
    {
      path: '/oldAgeChineseMedicine',
      name: 'oldAgeChineseMedicine',
      component: () => import('@/views/oldAgeChineseMedicine/index'),
      meta: { title: '中医报告' }
    },
    // 心藏报告
    {
      path: '/oldAgeHeartHidingReport',
      name: 'oldAgeHeartHidingReport',
      component: () => import('@/views/oldAgeChineseMedicine/HeartHidingReport')
    },
    // 心藏报告
    {
      path: '/HeartHidingReport',
      name: 'HeartHidingReport',
      component: () => import('@/views/chineseMedicine/HeartHidingReport')
    },
    // 图片展示
    {
      path: '/PictureDisplay',
      name: 'PictureDisplay',
      component: () => import('@/views/chineseMedicine/PictureDisplay')
    },
    // 历史报告
    {
      path: '/HistoricalReport',
      name: 'HistoricalReport',
      component: () => import('@/views/chineseMedicine/HistoricalReport')
    },
    // 冥想倒计时
    {
      path: '/meditation-timer',
      name: 'MeditationTimer',
      component: () => import('@/views/healthReport/components/MeditationTimer'),
      meta: { title: '冥想放松' }
    },
    // 冥想指引
    {
      path: '/meditation-guide',
      name: 'MeditationGuide',
      component: () => import('@/views/healthReport/components/MeditationGuide'),
      meta: { title: '冥想指引' }
    },
    {
      path: '/diet-suggestion',
      name: 'dietSuggestion',
      component: () => import('@/views/healthReport/dietSuggestion/index'),
      meta: { title: '饮食建议' }
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import('@/views/contacts/index'),
      meta: { title: '紧急联系人' }
    },
    {
      path: '/healthArchive',
      name: 'healthArchive',
      component: () => import('@/views/healthArchive/index'),
      meta: { title: '健康档案' }
    },
    {
      path: '/healthArchive/upload',
      name: 'healthArchiveUpload',
      component: () => import('@/views/healthArchive/UploadPage'),
      meta: { title: '图片上传' }
    },
    {
      path: '/survey',
      name: 'surveyPage',
      component: () => import('@/views/healthArchive/SurveyPage'),
      meta: { title: '调查问卷' }
    },
    {
      path: '/lead',
      name: 'lead',
      component: () => import('@/views/theHeart/lead')
    },
  ]
})

router.beforeEach((to, from, next) => {
  // 特殊账号（仅手机号 15210290982）入口映射：不影响其他手机号
  try {
    const raw = localStorage.getItem('userStore');
    if (raw) {
      const parsed = JSON.parse(raw);
      const phone =
        (parsed && parsed.userInfo && parsed.userInfo.userPhone)
          ? String(parsed.userInfo.userPhone).trim()
          : '';
      if (phone === '152102909821') {
        // 首页入口
        if (to.name === 'healthHomePage') {
          return next({ name: 'healthIconSwitch', query: to.query, replace: true });
        }
        // 报告入口（包含列表/失败列表等）
        if (
          to.name === 'healthReport' ||
          to.name === 'healthReportList' ||
          to.name === 'healthReportFailedList' ||
          to.path === '/health-report' ||
          to.path === '/health-report-list' ||
          to.path === '/health-report-failed-list'
        ) {
          return next({ name: 'serviceDashboard', query: to.query, replace: true });
        }
        // 设备入口（若存在旧入口，可在这里继续补充映射；目前 deviceHome 已单独路由）
      }
    }
  } catch (e) {
    // ignore
  }
  // 统一从空白健康页中转进入首页
  if (to.path === '/healthHomePage' && from.path !== '/health') {
    return next({ path: '/health', query: { next: to.fullPath } });
  }
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js